<template>
  <div>
    <template v-if="pageLoader">
      <v-progress-linear indeterminate color="primary"></v-progress-linear>
    </template>
    <v-card flat v-else>
      <v-card-text>
        <v-row class="ma-0">
          <v-col cols="12" md="4">
            <v-select dense outlined :items="listOfFormTypes" clearable @change="selectFieldsHandler(properties.type)" v-model="properties.type"
              :rules="$_requiredValidation"  hide-details item-text="text" item-value="value" :label="$t('message.props.type')">
              <template slot="append">
                  <v-icon size="26" color="primary">{{ appendIconObj.icon }}</v-icon>
              </template>
            </v-select>
          </v-col>
          <v-spacer></v-spacer>
          <div class="make-buttons-fixed">
            <v-layout justify-center>
              <template v-if="payload.from === 'forms'">
                <v-btn color="success test" tile :loading="loading" @click="updatePropertiesInForm">{{ $t('message.common.update') }}</v-btn>
              </template>
              <template v-else>
                <v-btn color="success test" tile :loading="loading" @click="saveUpdateHandler('SAVE')" dark v-if="!payload.propid" class="mr-2">{{ properties._id ? $t('message.common.update') : $t('message.common.save') }}</v-btn>
              </template>
              <v-btn color="info"  tile v-if="properties._id && payload.from === 'properties'" :loading="loading" @click="saveUpdateHandler('UPDATE_CLOSE')" dark>{{ $t('message.common.updateAndClose') }}</v-btn>
              <v-btn color="error" class="ml-1" tile :loading="loading" @click="closeDialogHandler">{{ $t('message.common.close') }}</v-btn>
            </v-layout>
           </div>
          <v-col cols="12" class="pl-0 pt-0">
            <v-card class="pa-0" flat>
              <v-card-title class="subtitle-2 px-2 py-0">
                <span class="text-uppercase"> {{ $t('message.props.formAttributes') }} </span>
              </v-card-title>
              <v-divider class="mx-2"></v-divider>
              <v-card-text>
                  <v-form ref="fieldsForm">
                    <v-container fluid class="pa-0">
                      <v-row v-if="![10, 19, 12, 18, 15].includes(properties.type)">
                        <v-col cols="4">
                          <v-text-field dense outlined hide-details :label="$t('message.props.name')" v-model="properties.name"
                            :rules="properties.name ? fieldAndUniqueValidation : $_requiredValidation"></v-text-field>
                        </v-col>
                        <v-col cols="4" v-if="![16, 5, 4].includes(properties.type)">
                          <v-text-field hide-details dense outlined :label="$t('message.props.label')" v-model="properties.label"></v-text-field>
                        </v-col>
                        <v-col cols="4">
                          <v-text-field dense type="number" outlined hide-details :label="$t('message.props.columns')" v-model="properties.columns"
                            :rules="columnValidation"></v-text-field>
                        </v-col>
                        <v-col cols="4"  v-if="![11, 13, 14, 16, 17].includes(properties.type)">
                          <v-autocomplete  hide-details dense outlined :items="validationList" v-model="properties.validation" clearable
                            @click:clear="properties.validation = null"
                            item-text="text" item-value="value" :label="$t('message.props.validation')">
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="4"  v-if="![3, 4, 8, 11, 13, 14, 16, 17].includes(properties.type)">
                          <v-text-field hide-details dense outlined :label="$t('message.props.placeholder')"  :rules="[5, 6, 7, 9].includes(properties.type)  ?  $_requiredValidation : []" v-model="properties.placeholder"></v-text-field>
                        </v-col>
                        <v-col cols="4"  v-if="![3, 9, 11, 13, 14].includes(properties.type) && !isAPI">
                          <v-text-field  v-if="[1,5,4].includes(properties.type)" dense outlined :label="$t('message.props.defaultValue')"
                            v-model="properties.default_value" persistent-hint  hide-details
                            :hint="radioSelectFields.includes(properties.type) ? $t('message.props.enterValue') : ''">
                          </v-text-field>
                          <v-textarea dense outlined  hide-details :label="$t('message.props.defaultValue')" v-model="properties.default_value" v-else-if="properties.type === 2"></v-textarea>
                          <v-menu v-model="dateMenu" :close-on-content-click="false" max-width="290"  v-else-if="properties.type === 6">
                            <template v-slot:activator="{ on }">
                              <v-text-field dense outlined v-model="properties.default_value" prepend-icon="mdi-calendar" :label="$t('message.props.defaultValue')"
                                readonly  hide-details v-on="on" @click:clear="properties.default_value = null, datePicker = null"></v-text-field>
                            </template>
                            <v-date-picker no-title dense v-model="datePicker" @change="dateMenu = false"></v-date-picker>
                          </v-menu>
                          <v-menu ref="timeMenu" v-model="timeMenu" v-else-if="properties.type === 7" :close-on-content-click="false" :nudge-right="40"
                            transition="scale-transition" :return-value.sync="time" offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on }">
                              <v-text-field   hide-details  dense outlined v-model="properties.default_value" :label="$t('message.props.defaultValue')"
                                prepend-icon="mdi-timer" readonly v-on="on"></v-text-field>
                            </template>
                            <v-time-picker dense v-if="timeMenu" v-model="properties.default_value" format="24hr"
                              @click:minute="$refs.timeMenu.save(properties.default_value)"></v-time-picker>
                          </v-menu>
                          <v-switch inset :label="$t('message.props.defaultValue')"  class="mt-0" v-model="properties.default_value" v-else-if="properties.type === 8"></v-switch>
                        </v-col>
                        <v-col cols="4" v-if="[6, 7].includes(properties.type)">
                          <v-select  hide-details dense outlined v-model="defaultValueKeyword" :items="this[`${properties.type === 6 ? 'date' : 'time'}KeywordList`]"
                          clearable item-value="keyword" :label="$t('message.props.defaultValueKeyword')"></v-select>
                        </v-col>
                        <v-col cols="3" lg="2" v-if="properties.type === 5">
                          <v-checkbox  hide-details  dense :label="$t('message.props.isApi')" v-model="isAPI"></v-checkbox>
                        </v-col>
                        <v-col cols="2" lg="2" v-if="properties.type === 5">
                          <v-checkbox dense  hide-details  :label="$t('message.props.isMultiSelect')" v-model="isMultiSelect"></v-checkbox>
                        </v-col>
                        <template v-if="properties.type === 3">
                          <v-col cols="3" class="pt-0">
                            <label class="subtitle-2">{{ $t('message.props.type') }}</label>
                            <v-radio-group dense class="mt-2" row v-model="checkboxProperties.checkboxtype">
                              <v-radio v-for="(view, index) in checkboxTypes" :key="index" :label="view.text"  hide-details :value="view.value"></v-radio>
                            </v-radio-group>
                          </v-col>
                          <template v-if="checkboxProperties.checkboxtype === 2">
                            <v-col cols="4" class="py-0">
                              <label class="subtitle-2"> {{ $t('message.props.viewType') }}</label>
                              <v-radio-group dense class="mt-2" row v-model="checkboxProperties.viewType">
                                <v-radio v-for="(view, index) in checkboxViews"  hide-details :key="index" :label="view.text" :value="view.value"></v-radio>
                              </v-radio-group>
                            </v-col>
                            <v-col cols="12">
                              <options-list :list="listOfOptions" ref="optionslistComponent"></options-list>
                            </v-col>
                          </template>
                        </template>
                        <v-col cols="12" class="py-0" v-if="properties.type === 4">
                          <options-list :list="listOfOptions" ref="optionslistComponent"></options-list>
                        </v-col>
                        <v-col cols="12" v-if="properties.type === 5 && !isAPI">
                          <options-list :list="listOfOptions" ref="optionslistComponent"></options-list>
                        </v-col>
                        <v-col cols="12" v-if="properties.type === 5 && isAPI">
                          <v-container class="pa-0">
                            <v-row>
                              <v-col cols="4">
                                <v-text-field dense  hide-details outlined :label="$t('message.props.apiUrl')" v-model="apiOptions.apiUrl"></v-text-field>
                              </v-col>
                              <v-col cols="4">
                                <v-text-field dense  hide-details outlined :label="$t('message.props.objectName')" v-model="apiOptions.objectName"></v-text-field>
                              </v-col>
                              <v-col cols="4">
                                <v-text-field dense  hide-details outlined :label="$t('message.props.name')" v-model="apiOptions.name"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-col>
                        <v-col cols="2" class="py-0" v-if="properties.type === 1">
                          <v-checkbox dense :label="$t('message.props.useAsTitle')" v-model="useAsTitle"></v-checkbox>
                        </v-col>
                        <!-- <v-col cols="12" v-if="payload.from === 'properties'">
                          <v-checkbox hide-details class="my-checkbox" :label="$t('favourite')" v-model="properties.favourite"></v-checkbox>
                        </v-col> -->
                      </v-row>
                      <v-row v-else>
                        <v-col cols="4">
                          <v-text-field dense outlined hide-details v-model="properties.name" :label="$t('message.props.name')"
                            :rules="properties.name ? fieldAndUniqueValidation : $_requiredValidation" required>
                          </v-text-field>
                        </v-col>
                        <v-col cols="4" v-if="properties.type !== 15">
                          <v-text-field dense outlined  hide-details :type="[12, 18].includes(properties.type) ? 'number' : 'text'"
                            v-model="properties.label" :label="[12, 18].includes(properties.type)? $t('message.props.gridColumns') : $t('message.props.question')">
                          </v-text-field>
                        </v-col>
                        <v-col cols="4" v-if="![15,18,19,10].includes(properties.type)">
                          <v-text-field dense type="number" outlined hide-details :label="$t('message.props.columns')" v-model="properties.columns"
                            :rules="columnValidation">
                          </v-text-field>
                        </v-col>
                        <v-col cols="4" v-if="![15,18,12].includes(properties.type)">
                          <v-textarea dense outlined :label="$t('message.props.link')" v-model="properties.html"></v-textarea>
                        </v-col>
                        <v-col cols="4" v-if="properties.type === 15">
                          <v-text-field  hide-details dense outlined v-model="properties.columns" :label="$t('message.props.columns')"
                            :rules="$_componentValidation" @input="updatedColumns()"></v-text-field>
                        </v-col>
                        <v-col cols="4" v-if="properties.type === 15">
                          <v-text-field  hide-details dense outlined type="number" v-model="properties.rows" :label="$t('message.props.rows')"></v-text-field>
                        </v-col>
                        <v-col cols="2" class="pr-0" v-if="properties.type === 19">
                          <v-checkbox  hide-details dense class="mx-2" :label="$t('message.props.signature')" v-model="checkboxFlags.signature"></v-checkbox>
                        </v-col>
                        <v-col cols="2" class="pr-0" v-if="properties.type === 19">
                          <v-checkbox dense class="mx-2" :label="$t('message.props.date')" v-model="checkboxFlags.date"></v-checkbox>
                        </v-col>
                        <v-col cols="2" class="pr-0"  v-if="[10,19].includes(properties.type)">
                          <v-checkbox  hide-details dense :label="$t('message.props.hideComments')" v-model="hideComments"></v-checkbox>
                        </v-col>
                        <v-col cols="4" class="pr-0" v-if="[10,19].includes(properties.type)">
                          <v-checkbox dense :label="$t('message.props.hideAttachments')" v-model="hideAttachments"></v-checkbox>
                        </v-col>
                        <v-col cols="4" v-if="properties.type === 18">
                          <v-checkbox  hide-details dense class="mx-2" :label="$t('message.props.showWidthField')" v-model="isWidthAboveHeader"></v-checkbox>
                        </v-col>
                        <v-col cols="12" v-if="[10, 19].includes(properties.type)">
                          <options-list :list="listOfAnswerOptions" :type="properties.type" ref="optionslistComponent"></options-list>
                        </v-col>
                      </v-row>
                      <v-row v-if="properties.type === 12 && properties.label">
                        <v-col cols="12" class="pt-0 pb-1">
                          <h5>{{ $t('message.props.enterTitleOfColumn') }}:</h5>
                          <div v-if="loadingGrids">
                            <h4>{{ $t('message.props.loadingGrid') }}</h4>
                            <v-progress-linear color="primary accent-4" indeterminate rounded height="6"></v-progress-linear>
                          </div>
                        </v-col>
                        <v-col cols="12" class="pt-0" v-if="!loadingGrids">
                          <v-card class="d-flex align-content-start flex-wrap pa-0" flat tile>
                            <v-card max-width="80" v-for="(grid, index) in listOfGridLabel" :key="index" class="pa-0" outlined tile>
                              <v-text-field  hide-details single-line dense full-width v-model="grid.label" outlined ></v-text-field>
                            </v-card>
                          </v-card>
                        </v-col>
                      </v-row>
                      <template v-if="properties.type === 16">
                        <v-row>
                          <v-col cols="6">
                            <span class="text-h6">{{ $t('message.props.link') }}</span>
                            <v-textarea  hide-details class="mt-2" outlined auto-grow dense v-model="properties.html_content"></v-textarea>
                          </v-col>
                          <v-col cols="6">
                            <span class="text-h6">{{ $t('message.props.preview') }}</span>
                            <div class="mt-2" v-html="properties.html_content"></div>
                          </v-col>
                        </v-row>
                      </template>
                      <template v-if="properties.type === 17">
                        <v-row>
                          <v-col cols="4">
                            <span>{{ $t('message.props.fontSize') }}</span>
                            <v-slider v-model="properties.font_size" :tick-labels="fontLabels" :max="3"
                              :step="0.5"
                              :min="0.5"
                              ticks="always"
                              tick-size="5">
                            </v-slider>
                          </v-col>
                          <v-col cols="12" md="3">
                            <span>{{ $t('message.props.preview') }}</span>
                            <span class='pa-0 subtitle-2' :style="{ fontSize: `${properties.font_size}em !important` }">
                              {{ properties.label }}</span>
                          </v-col>
                        </v-row>
                      </template>
                      <v-row v-if="properties.type === 18 && properties.label">
                        <v-col cols="12" class="pt-0 pb-1">
                          <h5>{{ $t('message.props.enterTitleAndWidthOfColumn') }}:</h5>
                          <div v-if="loadingGrids">
                            <h4>{{ $t('message.props.loadingGrid') }}</h4>
                            <v-progress-linear color="primary accent-4" indeterminate height="3"></v-progress-linear>
                          </div>
                        </v-col>
                        <v-col cols="12" class="pt-0" v-if="!loadingGrids">
                          <v-card flat class="apply-flex">
                            <v-card flat outlined :width="grid.colWidth" :min-width="grid.colWidth"
                              v-for="(grid, index) in listOfGridLabel" :key="index">
                                <v-row class="ma-0" no-gutters>
                                  <v-col class="pa-0" cols="12" v-if="isWidthAboveHeader">
                                    <!-- <v-text-field :rules="$_requiredAndMinValidation" flat type="number" class="text_field_no_radius centered-input"
                                      dense single-line full-width v-model="grid.width" @input="setWidthForGrid(grid)" outlined hide-details>
                                    </v-text-field> -->
                                      <v-text-field :rules="$_requiredAndMinValidation" flat type="number" class="text_field_no_radius centered-input"
                                        dense single-line full-width v-model="grid.width" @input="debouncedSetColWidth(grid)" outlined hide-details>
                                    </v-text-field>
                                  </v-col>
                                  <v-col class="pa-0" :cols="isWidthAboveHeader ? '12' : '9'">
                                    <v-text-field :rules="$_requiredValidation"  class="text_field_no_radius"
                                      dense v-model="grid.label" outlined hide-details></v-text-field>
                                  </v-col>
                                  <v-col class="pa-0" cols="3" v-if="!isWidthAboveHeader">
                                    <v-text-field :rules="$_requiredAndMinValidation" type="number"
                                      class="text_field_no_radius header-custom-padding" dense
                                      full-width v-model="grid.width" @input="setWidthForGrid(grid)" outlined hide-details>
                                    </v-text-field>
                                  </v-col>
                                </v-row>
                                <v-row class="ma-0">
                                  <v-col class="pa-0" cols="12">
                                    <v-select outlined :rules="$_requiredValidation" dense flat full-width hide-details
                                      :items="dataGridFieldTypes" item-text="text" item-value="value" :label="$t('message.props.type')"
                                      v-model="grid.field.type" @change="changeTypeProperties(grid.field)" class="text_field_no_radius">
                                      <template v-if="[fieldTypeConstants.CHECKBOX, fieldTypeConstants.SELECT, fieldTypeConstants.RADIOBOX].includes(grid.field.type)" slot="prepend">
                                        <v-icon @click="typeDataEdit(grid.field)" size="20" color="#90A4AE" class="ma-1">mdi-pencil</v-icon>
                                      </template>
                                    </v-select>
                                    <v-row v-if="[fieldTypeConstants.NUMBER, fieldTypeConstants.LABEL].includes(grid.field.type)"
                                      class="ma-0">
                                      <v-col class="pa-1">
                                        <div class="text-subtitle-2 text-center">{{ $t('message.props.fieldInfo') }}</div>
                                        <template v-if="grid.field.type === fieldTypeConstants.NUMBER">
                                          <v-row class="ma-0 pa-0" justify="center">
                                            <v-checkbox dense class="ma-0" hide-details v-model="grid.field.typedata.isshowsum"
                                              :label="$t('message.props.showSum')">
                                            </v-checkbox>
                                          </v-row>
                                        </template>
                                        <template v-else-if="grid.field.type === fieldTypeConstants.LABEL">
                                          <v-row justify="center" class="ma-0">
                                            <v-col cols="12" class="pa-0 pb-1 ma-0">
                                              <v-text-field  hide-details dense outlined v-model="grid.field.typedata.labeltext"
                                                :placeholder="$t('message.props.enterText')" class="text_field_no_radius">
                                              </v-text-field>
                                            </v-col>
                                            <v-col cols="12" class="pa-0">
                                              <v-text-field hide-details dense outlined type="number"
                                                v-model.number="grid.field.typedata.calculatingValue"
                                                :placeholder="$t('message.props.valueForCalculation')" class="text_field_no_radius">
                                              </v-text-field>
                                            </v-col>
                                            <v-col cols="12" class="pa-0">
                                              <v-radio-group dense class="mt-0" :rules="grid.field.typedata.calculatingValue ?
                                                $_requiredValidation : []" row hide-details v-model="grid.field.typedata.insertPosition">
                                                <v-radio v-for="(option, index) in insertPositionList" :key="index"
                                                  :label="option.label" :value="option.value">
                                                </v-radio>
                                              </v-radio-group>
                                            </v-col>
                                          </v-row>
                                        </template>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-card>
                          </v-card>
                        </v-col>
                      </v-row>
                      <v-row v-if="properties.type === 15">
                        <v-col cols="12" class="pt-0 pb-1">
                          <h5>{{ $t('message.props.enterTitleOfColumn') }}:</h5>
                          <div v-if="loadingGrids">
                            <h4>{{ $t('message.props.loadingGrid') }}</h4>
                            <v-progress-linear color="primary accent-4" indeterminate rounded height="6"></v-progress-linear>
                          </div>
                        </v-col>
                        <v-col cols="12" class="pt-0 proptable fixed-first-column">
                          <v-card-text class="pa-0" style="overflow-x:hidden;overflow-y:hidden">
                            <table border="0" class="dense_table" aria-describedby="grid">
                              <thead>
                                <tr>
                                  <th :id="index" style="max-width:300px; min-width:200px" v-for="(grid, index) in listOfGridLabel" :key="index">
                                    <v-text-field dense flat full-width v-model="grid.label" solo hide-details :placeholder="$t('message.props.enterTitle')"></v-text-field>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(row, rIndex) in listOfGridColumn" :key="rIndex">
                                  <td :id="dIndex" v-for="(grid, dIndex) in listOfGridLabel" :key="dIndex"
                                    :style="dIndex === 0 ? 'padding:0px;width:20%': 'padding:0px;border: none;width:20%'">
                                    <template v-if="dIndex === 0">
                                      <v-text-field dense flat full-width v-model="row.name" solo hide-details></v-text-field>
                                    </template>
                                    <template v-else>
                                      <tr>
                                        <td style="width:60%" class="pa-1">
                                          <v-text-field dense flat full-width v-model="row[`compValue_${dIndex}`]" solo hide-details></v-text-field>
                                        </td>
                                        <td style="width:25%" class="pa-1">
                                          <v-select dense flat full-width hide-details :items="inventCompItem" v-model="row[`compSelect_${dIndex}`]"></v-select>
                                        </td>
                                      </tr>
                                    </template>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </v-card-text>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
              </v-card-text>
              <v-card flat v-if="propertyGroupedByType.length" class="mx-3">
                  <v-card-title class="pa-1">
                    <h3>{{$t('message.props.customProperties')}}</h3>
                  </v-card-title>
                  <v-card-text class="px-1 py-2" v-if="listOfTypes.length">
                    <template v-for="(item, index) in listOfTypes">
                      <v-chip  label small class="mr-3 my-2" color="#E8EAF6" :key="index" @click="loadFieldValues(item)"> {{ item.name }}
                      </v-chip>
                    </template>
                  </v-card-text>
                  <v-card-text v-else>
                    <v-alert tile  type="error"  text prominent  dense icon="mdi-alert"> {{ $t('message.props.customFieldsNotAvailable')}}</v-alert>
                  </v-card-text>
                </v-card>
                <v-dialog scrollable max-width="1200" width="800" v-if="properties.type === 18" v-model="showPropertyDialog"
                  transition="dialog-bottom-transition" persistent>
                  <v-card>
                  <v-card-text class="pa-0">
                    <datagrid-field-properties v-if="showPropertyDialog" :propertyObj="propertyObjTypeData"
                      @saveClick="saveObjTypeData" @cancelClick="showPropertyDialog = false">
                    </datagrid-field-properties>
                    </v-card-text>
                  </v-card>
                </v-dialog>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { dataGridFieldTypes, listOfFormTypes } from '@/utils/checklistutils/support_list'
import { checklistApi } from '@/plugins/checklist_api'
import dataGridConstants from '@/mixins/Checklist/data_grid_component'
export default {
  props: {
    payload: {
      type: Object,
      default: () => {}
    },
    properties: {
      type: Object,
      default: () => {}
    },
    token: {
      type: String,
      default: () => ''
    },
    propertyGroupedByType: {
      type: Array,
      default: () => []
    },
    propertyNames: {
      type: Array,
      default: () => []
    }
  },
  mixins: [dataGridConstants],
  data () {
    return {
      listOfFormTypes: listOfFormTypes,
      typesNotInclude: [11, 13, 14, 16, 17],
      placeholderNotInclude: [3, 4, 8, 11, 13, 14, 16, 17],
      /* Date and Time */
      dateKeywordList: [{ text: 'CURDATE', keyword: 'CURDATE' }],
      timeKeywordList: [{ text: 'CURTIME', keyword: 'CURTIME' }],
      timeMenu: false,
      validationList: [{ text: 'Required', value: 'required' }],
      useAsTitle: false,
      isMultiSelect: false,
      datePicker: null,
      time: null,
      isAPI: false,
      // checkbox
      checkboxProperties: {
        viewType: 'default', // horizontal, vertical, default,
        checkboxtype: 1 // single-1, multiple-2
      },
      checkboxTypes: [{ text: 'Single', value: 1 }, { text: 'Multiple', value: 2 }],
      checkboxViews: [
        { text: 'Default', value: 'default' },
        { text: 'Horizontal', value: 'horizontal' },
        { text: 'Vertical', value: 'vertical' }
      ],
      checkboxFlags: { signature: true, date: true, notes: true },
      radioSelectFields: [4, 5],
      listOfOptions: [{ isactive: true }],
      dateMenu: false,
      apiOptions: {},
      listOfAnswerOptions: [{ label: 'Yes', value: 'yes', isactive: true }, { label: 'No', value: 'no', isactive: true }, { label: 'Not Applicable', value: 'not_applicable', isactive: true }],
      hideAttachments: false,
      hideComments: false,
      fontLabels: [0.5, 1, 1.5, 2, 2.5, 3],
      isWidthAboveHeader: false,
      loadingGrids: false,
      listOfGridLabel: [],
      gridHasData: false,
      preGridList: [],
      gridCount: 0,
      dataGridFieldTypes: dataGridFieldTypes,
      insertPositionList: [{ label: 'Prefix', value: 'prefix' }, { label: 'Suffix', value: 'suffix' }],
      propertyObjTypeData: {},
      showPropertyDialog: false,
      listOfGridColumn: [],
      optionsValueNotUnique: false,
      panelId: 0,
      propertiesObj: {},
      pageLoader: true,
      defaultValueKeyword: '',
      listOfTypes: [],
      loading: false,
      appendIconObj: {},
      preGridLabelList: [],
      preGridDataValue: []
    }
  },
  components: {
    'options-list': () => import('../property/OptionsList'),
    'datagrid-field-properties': () => import('./DataGridBuilderProperty/Index')
  },
  watch: {
    'properties.type' (type) {
      if (type === 15) this.listOfGridColumn = []
    },
    'properties.label' (val) {
      if (val && [12, 18].includes(this.properties.type)) {
        this.loadingGrids = true
        // this.getLoadedGrids()
        this.debouncedGetGrid()
      }
    },
    'properties.rows' (val) {
      if (val && this.properties.type === 15) {
        this.loadingGrids = true
        // this.getLoadedComponent()
        this.debouncedGetComponent()
      }
    },
    'datePicker' (val) {
      if (val) {
        // this.properties.default_value = this.$formatter.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
        this.properties.default_value = this.$formatter.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    }
  },
  computed: {
    ...mapState(['userDetails']),
    fieldAndUniqueValidation () {
      return [
        v => v ? /^[a-zA-Z0-9_]*$/.test(v) || 'Invalid name' : true,
        v => v && this.propertyNames ? !this.propertyNames.includes(v) || 'Name property exists' : true
      ]
    },
    columnValidation () {
      return [
        v => !!v || 'required',
        v => (v <= 12 && v >= 1) || 'enter columns b/w 1 to 12'
      ]
    }
  },
  mounted () {
    if (this.payload.propid || this.properties._id) {
      if (this.propertyNames) this.propertyNames.splice(this.propertyNames.indexOf(this.payload.name), 1) // For removing active property name from existing prop names
      const id = this.properties._id ? this.properties._id : this.payload.propid
      const type = this.payload.savedAlready ? 'formproperties' : 'properties'
      this.getSingleRecordHandler(id, type)
    }
    if (this.payload.type || this.propertyGroupedByType.length) this.getCustomProperties(this.payload.type)
    if (this.payload.setColumns) this.properties.columns = this.payload.setColumns
    if (!this.properties._id) this.appendIconForSelectedFiels(this.properties.type)
    setTimeout(() => {
      this.pageLoader = false
    }, 800)
    this.debouncedGetGrid = this.$formatter.debounce(this.getLoadedGrids, 500)
    this.debouncedGetComponent = this.$formatter.debounce(this.getLoadedComponent, 500)
    this.debouncedSetColWidth = this.$formatter.debounce((grid) => {
      if (grid.width > 50) grid.colWidth = grid.width
      else grid.colWidth = grid.width = 50
    }, 800)
    if (this.payload.isnewProperty) this.properties.type = 1
  },
  methods: {
    selectFieldsHandler (type) {
      if (this.propertyGroupedByType.length) this.getCustomProperties(type)
      this.appendIconForSelectedFiels(type)
      if (type === 12 || type === 18) this.preGridList = []
      if (type === 18) this.preGridLabelList = []
      this.properties.type = type
      if (this.$refs.fieldsForm) this.$refs.fieldsForm.resetValidation()
      const properties = { _id: this.properties._id ? this.properties._id : null, is_active: true, favourite: false, type: this.properties.type }
      this.$emit('change', properties)
    },
    getSingleRecordHandler (id, type) {
      const url = type === 'properties' ? `properties/${id}` : `formproperties/${id}`
      checklistApi.get(url, this.token).then((result) => {
        if (result && result.data) {
          // this.pageLoader = false
          let model = this.$formatter.cloneVariable(result.data)
          model.validation = model.validation ? model.validation : null
          const values = model.default_value ? JSON.parse(model.default_value) : null
          model = this.construtValues(values, model)
          if (this.payload) model.name = this.payload && this.payload.name ? this.payload.name : model.name
          this.$emit('change', model)
          this.appendIconForSelectedFiels(result.data.type)
        }
      })
    },
    // re-assigning values to the variables
    construtValues (values, model) {
      switch (model.type) {
        case 1:
          this.useAsTitle = values.use_as_title
          model.default_value = values.default_value
          this.panelId = values.panelId
          break
        case 3:
          this.listOfOptions = values.options
          this.checkboxProperties.viewType = values.viewType
          this.checkboxProperties.checkboxtype = values.checkboxtype
          this.panelId = values.panelId
          break
        case 4:
        case 5:
          this.isMultiSelect = values.is_multiselect
          switch (values.isAPI) {
            case true:
              this.apiOptions = { apiUrl: values.apiUrl, name: values.name, objectName: values.objectName }
              this.isAPI = values.isAPI
              model.default_value = values.default_value
              break
            default:
              this.listOfOptions = values.options
              model.default_value = values.default_value
              break
          }
          this.panelId = values.panelId
          break
        case 6:
        case 7:
          this.defaultValueKeyword = values.default_Value_keyword
          if (model.type === 6) {
            model.default_value = this.$formatter.formatDate(values.default_value, 'YYYY-MM-DDTHH:mm:ss' || 'DD.MM.YYYY', 'DD.MM.YYYY')
            this.datePicker = this.$formatter.formatDate(values.default_value, 'YYYY-MM-DDTHH:mm:ss' || 'DD.MM.YYYY', 'YYYY-MM-DD')
          } else model.default_value = values.default_value
          this.panelId = values.panelId
          break
        case 16:
          model.html_content = values.html_content
          this.panelId = values.panelId
          break
        case 15:
          model.rows = values.rows
          model.columns = values.columns
          this.listOfGridLabel = values.grid_header
          this.preGridLabelList = values.grid_header.labels
          this.preGridDataValue = values.grid_data.values
          this.gridCount = model.label
          this.gridColumnHasData = true
          this.gridHasData = true
          this.loadingGrids = true
          // this.getLoadedComponent()
          this.debouncedGetComponent()
          this.panelId = values.panelId
          break
        case 17: model.font_size = values.font_size
          this.panelId = values.panelId
          break
        case 12:
        case 18:
          this.listOfGridLabel = values.grid_data.labels ? values.grid_data.labels : []
          this.preGridList = values.grid_data.labels ? values.grid_data.labels : []
          this.gridCount = model.label
          this.gridHasData = true
          this.panelId = values.panelId
          if (model.type === 18) {
            this.gridHeaderAdded = true
            this.isWidthAboveHeader = values.isWidthAboveHeader
          }
          break
        case 10:
        case 19:
          this.hideAttachments = values.hideAttachments || false
          this.hideComments = values.hideComments || false
          this.listOfAnswerOptions = values.options
          this.panelId = values.panelId
          if (model.type === 19) this.checkboxFlags = values.checkboxFlags || { signature: true, date: true, notes: true }
          break
        default:
          model.default_value = values.default_value || null
          this.panelId = values.panelId
          break
      }
      return model
    },
    // save and update propety
    saveUpdateHandler (type) {
      if (this.$refs.fieldsForm.validate() && this.isOptionsValid()) {
        const constructModel = this.$formatter.cloneVariable(this.properties)
        if ([6, 7].includes(constructModel.type) && constructModel.default_value && this.defaultValueKeyword) constructModel.default_value = ''
        if (constructModel.type === 6) {
          constructModel.default_value = this.$formatter.formatDate(constructModel.default_value, 'DD.MM.YYYY', 'YYYY-MM-DDTHH:mm:ss')
        }
        constructModel.validation = constructModel.validation || null
        const properties = this.constructDefaultValue(constructModel)
        let model = this.addPanelIdHandler(properties, false, constructModel)
        model = this.$formatter.cloneVariable(model)
        checklistApi[model._id ? 'put' : 'post'](model._id ? `properties/${model._id}` : 'properties', model, this.token).then(response => {
          this.$emit('update', { data: response, status: 'success', type, action: model._id ? 'update' : 'add' })
        }).catch((error) => {
          this.$emit('update', { data: error, status: 'error', type })
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.optionsValueNotUnique ? 'optionsListValuesOrLabelsAreNotUnique' : 'validationIssue' })
      }
    },
    // for constrcting default value
    constructDefaultValue (model) {
      switch (model.type) {
        case 1: return { use_as_title: this.useAsTitle }
        case 3: return { viewType: this.checkboxProperties.viewType, options: this.listOfOptions, checkboxtype: this.checkboxProperties.checkboxtype }
        case 4:
        case 5:
          if (model.type !== 4) this.propertiesObj.is_multiselect = this.isMultiSelect
          switch (this.isAPI) {
            case true: return { ...this.apiOptions, isAPI: this.isAPI, is_multiselect: this.isMultiSelect }
            case false: this.propertiesObj.options = this.listOfOptions
              return this.propertiesObj
          }
          break
        case 6:
        case 7: return { default_Value_keyword: this.defaultValueKeyword }
        case 12:
        case 18: this.propertiesObj = { grid_data: { labels: this.listOfGridLabel, data: {} } }
          if (model.type === 18) this.propertiesObj.isWidthAboveHeader = this.isWidthAboveHeader
          return this.propertiesObj
        case 15: return { grid_header: { labels: this.listOfGridLabel }, grid_data: { values: this.listOfGridColumn }, columns: this.properties.columns, rows: this.properties.rows }
        case 16: return { html_content: this.properties.html_content }
        case 17: return { font_size: this.properties.font_size }
        case 10:
        case 19: this.propertiesObj = { hideComments: this.hideComments, hideAttachments: this.hideAttachments, options: this.listOfAnswerOptions }
          if (model.type === 19) this.propertiesObj.checkboxFlags = this.checkboxFlags
          return this.propertiesObj
        default: return this.propertiesObj
      }
    },
    // loading data for cutom fields
    loadFieldValues (item) {
      checklistApi.get(`properties/${item._id}`)
        .then((result) => {
          if (result && result.data) {
            let model = this.$formatter.cloneVariable(result.data)
            model.validation = model.validation ? model.validation : null
            model._id = null
            const values = model.default_value ? JSON.parse(model.default_value) : null
            if (values) model = this.construtValues(values, model)
            this.$emit('change', model)
          }
        })
    },
    // Adding panel Id
    addPanelIdHandler (propertiesObj, form, model) {
      if (![12, 18, 15, 19, 16, 17, 3, 10].includes(model.type)) propertiesObj.default_value = model.default_value
      const fieldObj = { panelId: model.panelid ? model.panelid : this.panelId, ...propertiesObj }
      model.default_value = form ? fieldObj : JSON.stringify(fieldObj)
      return model
    },
    // for updating properties in Form builder
    updatePropertiesInForm () {
      if (this.$refs.fieldsForm.validate() && this.isOptionsValid()) {
        const constructModel = this.$formatter.cloneVariable(this.properties)
        if (constructModel.type === 6) {
          constructModel.default_value = this.$formatter.formatDate(constructModel.default_value, 'DD.MM.YYYY', 'YYYY-MM-DDTHH:mm:ss')
        }
        const properties = this.constructDefaultValue(constructModel)
        const model = this.addPanelIdHandler(properties, true, constructModel)
        this.$root.$emit('updateProperty', { model: model, update: this.payload.savedAlready })
      } else {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.optionsValueNotUnique ? 'optionsListValuesAreNotUnique' : 'validationIssue' })
      }
    },
    getCustomProperties (type) {
      if (this.propertyGroupedByType.length) this.listOfTypes = this.propertyGroupedByType.filter(x => x.type === type)
    },
    updatedColumns () {
      if (this.properties.columns && this.properties.type === 15) {
        this.loadingGrids = true
        // this.getLoadedComponent()
        this.debouncedGetComponent()
      }
    },
    // for type [12,18] constrcting grid and data grid
    getLoadedGrids () {
      let grids = isNaN(this.properties.label) ? 0 : Number(this.properties.label)
      if (grids < 0) grids = this.$formatter.conventToPositive(grids)
      const gridList = this.preGridList.length ? this.$formatter.cloneVariable(this.preGridList) : []
      if (gridList.length) {
        this.listOfGridLabel = this.addLabelsColumnHandler(gridList, grids)
      } else {
        for (let i = 0; i < grids; i++) {
          let obj = { label: '' }
          if (this.properties.type === 18) obj = { ...obj, ...{ width: this.$formatter.findWidthPixel(grids), colWidth: this.$formatter.findWidthPixel(grids), field: { type: '', typedata: {} } } }
          gridList.push(obj)
        }
        this.listOfGridLabel = gridList
      }
      this.listOfGridLabel = gridList
      this.loadingGrids = false
    },
    // for type 15 constrcting Invent Component
    getLoadedComponent () {
      let grids = isNaN(this.properties.columns) ? 0 : Number(this.properties.columns)
      if (grids < 0) grids = this.$formatter.conventToPositive(grids)
      const gridList = this.preGridLabelList.length ? this.$formatter.cloneVariable(this.preGridLabelList) : []
      if (grids <= 5) {
        if (gridList.length) {
          this.listOfGridLabel = this.addLabelsColumnHandler(gridList, grids)
        } else {
          for (let i = 0; i < grids; i++) {
            gridList.push({ label: '' })
          }
          this.listOfGridLabel = gridList
        }
      }
      let columns = Number(this.properties.rows)
      if (columns < 0) columns = this.$formatter.conventToPositive(columns)
      const columnsList = this.preGridDataValue.length ? this.$formatter.cloneVariable(this.preGridDataValue) : []
      if (columnsList.length) {
        this.listOfGridColumn = this.addLabelsColumnHandler(columnsList, columns)
      } else {
        for (let i = 0; i < columns; i++) {
          let item = { name: `${i + 1}. ` }
          for (let j = 0; j < columns; j++) {
            item = { ...item, [`compValue_${j}`]: '', [`compSelect_${j}`]: '' }
          }
          columnsList.push(item)
        }
        this.listOfGridColumn = columnsList
      }
      this.loadingGrids = false
    },
    // when updating type 12, 18, 15 adding labels and columns
    addLabelsColumnHandler (gridList, grids) {
      if (gridList.length < grids) {
        for (let i = gridList.length; i < grids; i++) {
          let obj = { label: '' }
          if (this.properties.type === 18) obj = { ...obj, ...{ width: this.$formatter.findWidthPixel(grids), colWidth: this.$formatter.findWidthPixel(grids), field: { type: '', typedata: {} } } }
          if (this.properties.type === 15) obj = { name: `${i + 1}. `, [`compValue_${i}`]: '', [`compSelect_${i}`]: '' }
          gridList.push(obj)
        }
      } else {
        gridList.splice(grids, Math.abs((grids - (gridList.length))))
      }
      return gridList
    },
    // for type 18 DataGrid typedata constrcting
    changeTypeProperties (field) {
      field.typedata = {}
      if ([this.fieldTypeConstants.CHECKBOX, this.fieldTypeConstants.SELECT, this.fieldTypeConstants.RADIOBOX].includes(field.type)) {
        field.typedata.listItems = [{ isactive: true }]
        if (this.fieldTypeConstants.RADIOBOX !== field.type) {
          field.typedata.isMultiSelect = false
        }
        this.propertyObjTypeData = field
        this.showPropertyDialog = true
      }
    },
    typeDataEdit (field) {
      this.propertyObjTypeData = field
      this.showPropertyDialog = true
    },
    saveObjTypeData (val) {
      this.propertyObjTypeData = val
      this.showPropertyDialog = false
    },
    // setting default width for DataGrid 18
    setWidthForGrid (grid) {
      if (grid.width > 50) grid.colWidth = grid.width
      else grid.colWidth = grid.width = 50
    },
    // validation for type 3, 4, 5, 10, 19 options values duplication
    isOptionsValid () {
      let isOptionsListValid = true
      let options = []
      if (this.properties.type === 3 && this.checkboxProperties.checkboxtype === 2) {
        options = this.listOfOptions
      } else if ([4, 5].includes(this.properties.type)) {
        options = this.isAPI ? [] : this.listOfOptions
      } else if ([10, 19].includes(this.properties.type)) {
        options = this.listOfAnswerOptions
      } else {
        isOptionsListValid = true
      }
      if (options.length) {
        let hasDuplicate = this.$formatter.optionsValuesDuplication(options)
        let hasLabelDuplicte = this.$formatter.optionsLabelDuplication(options)
        if (hasLabelDuplicte) hasDuplicate = true
        if (hasDuplicate) hasLabelDuplicte = true
        const isValid = this.$refs.optionslistComponent.$refs.optionsList.validate()
        isOptionsListValid = isValid && !hasDuplicate && !hasLabelDuplicte
        this.optionsValueNotUnique = isValid && hasDuplicate && hasLabelDuplicte
      }
      return isOptionsListValid
    },
    closeDialogHandler () {
      this.apiOptions = {}
      this.listOfOptions = [{}]
      this.$emit('closeForm')
    },
    appendIconForSelectedFiels (type) {
      if (type) this.appendIconObj = this.listOfFormTypes.find(item => item.value === type)
    }
  }
}
</script>
<style scoped>
.custom-scroll {
  overflow-x:hidden !important;
  overflow-y: hidden;
}
::v-deep .my-checkbox .v-label {
 font-size: 1.1rem !important;
 font-weight: 500;
 color: rgba(0, 0, 0, 0.7) !important;
}
  /* Hide HTML5 Up and Down arrows. */
  .custom-number-field input[type="number"]::-webkit-outer-spin-button, .custom-number-field input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .custom-number-field input[type="number"] {
    -moz-appearance: textfield;
  }
</style>
<style scoped>
  .fixed-first-column table > tbody > tr > td:nth-child(1),
  .fixed-first-column table > thead > tr > th:nth-child(1) {
    position: sticky;
    width: 100px;
    left: 0;
    top: auto;
    z-index: 10;
    background-color: white;
  }
  .align-flex-end {
    align-self: flex-end;
  }
  .apply-flex {
    display:flex !important;
    flex-wrap: wrap !important;
    /* overflow: auto !important; */
    overflow: hidden !important;
  }
  .make-buttons-fixed {
    position:fixed !important;
    right:0 !important;
    z-index:1000 !important;
    padding-right:10px !important;
  }
</style>
